import { useLocationLogEntries } from "../../hooks/useLocationLogEntries.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationLogEntries/LocationLogEntryTitles.tsx
var LocationLogEntryTitles = ({ entryIds, listAll = true }) => {
	const { data, loading } = useLocationLogEntries({ entryIds }, { cacheStrategy: "cache-only" });
	if (!data?.entries && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.entries || !entryIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.entries[0].title
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.entries.map(({ title }) => title).join(", ") });
};
//#endregion
export { LocationLogEntryTitles };

//# sourceMappingURL=LocationLogEntryTitles.js.map